const floatingElement = document.getElementsByClassName('floating--js');

if (floatingElement.length) {
    for (let i = 0; i < floatingElement.length; i++) {
        let initialOffset = floatingElement[i].getBoundingClientRect().top;

        window.addEventListener('scroll', function() {
            let scrollY = window.scrollY;
            let windowHeight = window.innerHeight;
            let topValue = (initialOffset - scrollY) * -.055;
            floatingElement[i].style.top = topValue + 'px';
        });
    }
}